import { render, staticRenderFns } from "./PageFooterBlackFriday.vue?vue&type=template&id=7d3124aa&"
import script from "./PageFooterBlackFriday.vue?vue&type=script&lang=js&"
export * from "./PageFooterBlackFriday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports